import * as commonSelectors from 'apps/templates/selectors/commonSelectors'

export const getDraft = (state) => state.templates?.draft || {}

export const getDraftTemplate = (state) => getDraft(state).template

export const getDraftMap = (state) => getDraft(state).map || {}

export const getDraftTemplateShareType = (state) =>
  commonSelectors.getShareType(getDraftTemplate(state))

export const getDraftTemplateShareLink = (state) =>
  commonSelectors.getShareLink(getDraftTemplate(state))

export const getIsGeneratingLink = (state) =>
  commonSelectors.getIsGeneratingLink(getDraftTemplate(state))

export const hasFlowAppWithStatus = (item, flowId, status) =>
  getDependedAppsWithStatus(item, flowId, status).some((app) => app.status === status)

export const getDependedAppsWithStatus = (item, flowId, status) => {
  const { apps, dependencies } = item
  return (dependencies?.[flowId] || [])
    .filter((el) => el.startsWith('app_'))
    .map((el) => +el.substring(4))
    .map((appId) => apps.find((el) => el.id === appId))
    .filter((app) => app.status === status)
}
